import SessionHelper from "../Helper/SessionHelper";
class CartListCount {
    CartListCountURL(){
        return process.env.REACT_APP_BASEURL+"CartCount/"+SessionHelper.getMobile();
    }
}
export const {CartListCountURL}=new CartListCount();